import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from '@storable/canaveral-components';
import HidableInput from 'components/HidableInput/HidableInput';
import Icon from '../../../../../../modules/react/components/stateless/Icon';
import style from './RedirectTable.scss';

export default class RedirectTable extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    redirects: PropTypes.arrayOf(PropTypes.shape({
      source: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
    })),
    onAdd: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  };

  handleChange = (index, field) => ({ target }) => {
    this.props.onChange(
      index,
      { [field]: target.value },
    );
  }

  render() {
    const {
      title, redirects, onAdd, onDelete,
    } = this.props;

    return (
      <div className={style.root}>
        <h2 className={style.mainHeading}>{title}</h2>

        <Container fluid>
          {redirects.length > 0 ?
            <Row className={style.heading}>
              <Col xs={5}>
                Source URL
              </Col>
              <Col xs={5}>
                Target URL
              </Col>
              <Col xs={2} className={style.delete}>
                Delete
              </Col>
            </Row>
            : false
          }
          {redirects.map(({ source, target }, index) => (
            <Row key={`redirect-${index}`}>
              <Col
                xs={5}
                className={style.typable}
              >
                <HidableInput
                  value={source}
                  onChange={this.handleChange(index, 'source')}
                  placeholder="Source URL"
                  blurOnEmpty={false}
                  showOnEmpty
                  required
                />
              </Col>
              <Col xs={5} className={style.typable}>
                <HidableInput
                  value={target}
                  onChange={this.handleChange(index, 'target')}
                  placeholder="Target URL"
                  blurOnEmpty={false}
                  showOnEmpty
                  required
                />
              </Col>
              <Col xs={2} className={style.deleteColumn}>
                <Button
                  icon="exit"
                  context="bare"
                  onClick={() => onDelete(index)}
                  label="Delete Redirect"
                />
              </Col>
            </Row>
          ))}
          <Row className={style.addRow} onClick={onAdd}>
            <Col xs={12} className={style.text}>
              <Icon id="add" className={style.addIcon} label="Add Redirect" />
              {' '}
              Add new redirect
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
